module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS10.afd256a9.jpg";